import { call, put, takeLatest } from 'redux-saga/effects';

import { fetchReferenceDataApi } from '../../api';
import {
  fetchReferenceData,
  referenceDataSuccess,
  referenceDataError,
} from '../slices/referencesSlice';

function* fetchReferenceDataWorker(action) {
  try {
    const { status, ok, data } = yield call(
      fetchReferenceDataApi,
      action.payload
    );

    if (ok) {
      yield put(referenceDataSuccess(data));
    } else {
      yield put(referenceDataError({ status, data }));
    }
  } catch (err) {
    throw new Error(`Error: ${err.message}`);
  }
}

export default function* referenceSaga() {
  yield takeLatest(fetchReferenceData.type, fetchReferenceDataWorker);
}
